import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanReadCSA = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const readPermissionSelf: UserPermission = {
    resource: 'csa',
    action: 'readbasic',
    scope: 'self',
  };

  const canReadAll = useHasPermission(user, readPermissionSelf);
  return canReadAll;
};
